import React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./settlements.module.css";

export const Settlements = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const basePath = "/settlements";
  const isStatisticsTab = location.pathname.includes(`${basePath}/statistics`);
  const tabValue = isStatisticsTab ? 1 : 0;

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    navigate(newValue === 1 ? `${basePath}/statistics` : basePath);
  };

  return (
    <Box className={styles.container}>
      <Tabs value={tabValue} onChange={handleTabChange}>
        <Tab label={t("Sale summary")} />
        <Tab label={t("Statistics")} />
      </Tabs>
      <Box className={styles.content}>
        <Outlet />
      </Box>
    </Box>
  );
};
